"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@comunica/core");
/**
 * A comunica mediator that takes the union of all actor results.
 *
 * The actors that are registered first will have priority on setting overlapping fields.
 */


var MediatorCombineUnion =
/*#__PURE__*/
function (_core_1$Mediator) {
  _inherits(MediatorCombineUnion, _core_1$Mediator);

  function MediatorCombineUnion(args) {
    var _this;

    _classCallCheck(this, MediatorCombineUnion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MediatorCombineUnion).call(this, args));
    _this.combiner = _this.createCombiner();
    return _this;
  }

  _createClass(MediatorCombineUnion, [{
    key: "mediate",
    value: function () {
      var _mediate = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var testResults, results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                try {
                  testResults = this.publish(action);
                } catch (e) {
                  testResults = [];
                } // Delegate test errors.


                _context.next = 3;
                return Promise.all(testResults.map(function (_ref) {
                  var reply = _ref.reply;
                  return reply;
                }));

              case 3:
                _context.next = 5;
                return Promise.all(testResults.map(function (result) {
                  return result.actor.runObservable(action);
                }));

              case 5:
                results = _context.sent;
                return _context.abrupt("return", this.combiner(results));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mediate(_x) {
        return _mediate.apply(this, arguments);
      }

      return mediate;
    }()
  }, {
    key: "mediateWith",
    value: function mediateWith(action, testResults) {
      throw new Error("Method not supported.");
    }
  }, {
    key: "createCombiner",
    value: function createCombiner() {
      var _this2 = this;

      return function (results) {
        var data = {};
        data[_this2.field] = require('lodash.defaults').apply({}, [{}].concat(results.map(function (result) {
          return result[_this2.field];
        })));
        return data;
      };
    }
  }]);

  return MediatorCombineUnion;
}(core_1.Mediator);

exports.MediatorCombineUnion = MediatorCombineUnion;